(() => {
  const init = root => {
    root.querySelectorAll('.product-video-reel').forEach(reel => {
      if (reel.dataset.scrollbarReady) return;

      const track = reel.querySelector('[data-product-video-track]');
      const scrollbar = reel.querySelector('[data-product-video-scrollbar]');
      if (!track || !scrollbar) return;

      reel.dataset.scrollbarReady = 'true';

      let dragging = false;
      let startX = 0;
      let startScroll = 0;

      track.addEventListener('scroll', () => {
        const max = track.scrollWidth - track.clientWidth;
        scrollbar.value = max > 0 ? (track.scrollLeft / max) * 100 : 0;
      }, { passive: true });

      scrollbar.addEventListener('input', () => {
        const max = track.scrollWidth - track.clientWidth;
        track.scrollLeft = (Number(scrollbar.value) / 100) * max;
      });

      track.addEventListener('wheel', event => {
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        const canScroll = event.deltaY < 0
          ? track.scrollLeft > 0
          : track.scrollLeft < track.scrollWidth - track.clientWidth;
        if (!canScroll) return;
        track.scrollLeft += event.deltaY;
        event.preventDefault();
      }, { passive: false });

      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse') return;
        dragging = true;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });

      track.addEventListener('pointermove', event => {
        if (!dragging) return;
        track.scrollLeft = startScroll - (event.clientX - startX);
      });

      const stopDragging = event => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      };

      track.addEventListener('pointerup', stopDragging);
      track.addEventListener('pointercancel', stopDragging);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
